<template>
<section v-if="metrics.length" class="border-y border-slate-100 bg-white/80">
  <div class="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between">
    <div v-if="headline" class="text-sm font-semibold uppercase tracking-[0.3em] text-slate-400">{{ headline }}</div>
    <div class="grid flex-1 grid-cols-2 gap-6 md:grid-cols-4">
      <div v-for="metric in metrics" :key="metric.title" class="rounded-2xl border border-slate-100 bg-slate-25/60 px-5 py-4 text-center shadow-sm">
        <p class="text-2xl font-semibold text-slate-900">{{ metric.value }}</p>
        <p class="mt-2 text-xs uppercase tracking-wide text-slate-400">{{ metric.title }}</p>
      </div>
    </div>
  </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
});

const sectionContent = computed(() => props.content || {});
const headline = computed(() => sectionContent.value.headline || sectionContent.value.title || 'Niềm tin của doanh nghiệp đang tăng trưởng');
const metrics = computed(() => {
  const items = Array.isArray(sectionContent.value.items) ? sectionContent.value.items : [];
  return items.filter(item => item?.title && item?.value);
});
</script>
